import React, { useState } from 'react';
import { ThemeProvider } from './components/theme/ThemeProvider';
import { WalletProvider } from './components/wallet/WalletProvider';
import { StealthModeProvider } from './components/stealth-mode/StealthModeProvider';
import { MainLayout } from './components/layout/MainLayout';
import { LandingPage } from './components/auth/LandingPage';
import { Toaster } from './components/ui/sonner';
import { initializeErrorHandling } from './utils/error-handler';
import { toast } from 'sonner';

// Initialize error handling on app load
initializeErrorHandling();

// Crear contexto de autenticación
interface AuthContextType {
  isAuthenticated: boolean;
  userData: { email: string; name: string } | null;
  logout: () => void;
}

export const AuthContext = React.createContext<AuthContextType>({
  isAuthenticated: false,
  userData: null,
  logout: () => {},
});

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [userData, setUserData] = useState<{ email: string; name: string } | null>(null);

  const handleEmailSubmit = async (email: string, name: string) => {
    setIsLoading(true);
    
    // Simulate async authentication
    setTimeout(() => {
      console.log('✅ User authenticated:', { email, name });
      setUserData({ email, name });
      setIsAuthenticated(true);
      setIsLoading(false);
      toast.success(`Welcome to Nardium, ${name}! 🚀`);
    }, 1000);
  };

  const handleLogout = () => {
    console.log('🚪 User logged out');
    setIsAuthenticated(false);
    setUserData(null);
    localStorage.removeItem('walletConnection');
    toast.info('You have been logged out');
  };

  // Si no está autenticado, mostrar landing page
  if (!isAuthenticated) {
    return <LandingPage onEmailSubmit={handleEmailSubmit} isLoading={isLoading} />;
  }

  // Si está autenticado, mostrar la aplicación con contexto
  const authContextValue: AuthContextType = {
    isAuthenticated,
    userData,
    logout: handleLogout,
  };

  return (
    <AuthContext.Provider value={authContextValue}>
      <MainLayout />
    </AuthContext.Provider>
  );
}

export default function AppWrapper() {
  return (
    <ThemeProvider>
      <WalletProvider>
        <StealthModeProvider>
          <div className="min-h-screen bg-background text-foreground">
            <App />
            <Toaster />
          </div>
        </StealthModeProvider>
      </WalletProvider>
    </ThemeProvider>
  );
}